import axios from "axios";
import { BaseApiUrl } from "@/globals";

export default {
  namespaced: true,
  state: {
    listaDeVendas: [],
  },
  getters: {
    getListaDeVendas(state) {
      return state.listaDeVendas;
    },
  },
  mutations: {
    setListaDeVendas(state, payload) {
      state.listaDeVendas = payload;
    },
  },
  actions: {
    getListaDeVendas: (context) => {
      const usuario = context.rootGetters["usuario/USER_DATA"];
      const idVendedor = usuario.id;
      axios(`${BaseApiUrl}/vendas/porvendedor/${idVendedor}`).then((vendas) => {
        context.commit("setListaDeVendas", vendas.data);
      });
    },
  },
};
